import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-3" }
const _hoisted_2 = { class: "mt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link active",
      id: "shisetsu-tab",
      "data-toggle": "tab",
      "aria-selected": "true",
      href: "#yukei-panel",
      role: "tab",
      "aria-controls": "yukei-panel"
    }, "長期貸付金")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "unei-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#mukei-panel",
      role: "tab",
      "aria-controls": "mukei-panel"
    }, "短期貸付金")
  ])
], -1)
const _hoisted_4 = { class: "tab-content" }
const _hoisted_5 = {
  class: "tab-pane fade show active",
  id: "yukei-panel",
  role: "tabpanel",
  "aria-labelledby": "yukei-tab"
}
const _hoisted_6 = { class: "mt-3 pl-3 pl-3" }
const _hoisted_7 = { class: "mt-3 float-right" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  class: "tab-pane fade",
  id: "mukei-panel",
  role: "tabpanel",
  "aria-labelledby": "mukei-tab"
}
const _hoisted_10 = { class: "mt-3 pl-3 pl-3" }
const _hoisted_11 = { class: "mt-3 float-right" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_junsoku_setting_title = _resolveComponent("junsoku-setting-title")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_kashitsukekin_setting_long_item = _resolveComponent("kashitsukekin-setting-long-item")!
  const _component_kashitsukekin_setting_short_item = _resolveComponent("kashitsukekin-setting-short-item")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, { loading: _ctx.loading }, {
    header: _withCtx(() => [
      _createVNode(_component_junsoku_setting_title, { "main-title": "貸付金明細表" })
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_loading_button, {
          color: "primary",
          loading: _ctx.loading,
          disabled: !_ctx.isAllValid,
          onClick: _ctx.onClickRegister
        }, {
          default: _withCtx(() => [
            _createTextVNode("登録")
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])
      ]),
      _createVNode(_component_response_result_alert, {
        class: "mt-3",
        "is-succeed": _ctx.isSucceedRequest,
        "error-message": _ctx.requestError,
        onDismiss: _ctx.onDismissAlert
      }, null, 8, ["is-succeed", "error-message", "onDismiss"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.longItems, (item, index) => {
                return (_openBlock(), _createBlock(_component_kashitsukekin_setting_long_item, {
                  key: item.item.id,
                  item: item,
                  "is-first": index === 0,
                  "is-last": index === (_ctx.longItems.length - 1),
                  onUpItem: _cache[0] || (_cache[0] = (v) => _ctx.upItem('Long', v)),
                  onDownItem: _cache[1] || (_cache[1] = (v) => _ctx.downItem('Long', v)),
                  onTrashItem: _cache[2] || (_cache[2] = (v) => _ctx.trashItem('Long', v)),
                  onChangeInput: _cache[3] || (_cache[3] = (v) => _ctx.onChangeInput('Long', v))
                }, null, 8, ["item", "is-first", "is-last"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addLongItem && _ctx.addLongItem(...args))),
                disabled: _ctx.longItems.length >= 10
              }, "項目を追加", 8, _hoisted_8)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shortItems, (item, index) => {
                return (_openBlock(), _createBlock(_component_kashitsukekin_setting_short_item, {
                  key: item.item.id,
                  item: item,
                  "is-first": index === 0,
                  "is-last": index === (_ctx.shortItems.length - 1),
                  onUpItem: _cache[5] || (_cache[5] = (v) => _ctx.upItem('Short', v)),
                  onDownItem: _cache[6] || (_cache[6] = (v) => _ctx.downItem('Short', v)),
                  onTrashItem: _cache[7] || (_cache[7] = (v) => _ctx.trashItem('Short', v)),
                  onChangeInput: _cache[8] || (_cache[8] = (v) => _ctx.onChangeInput('Short', v))
                }, null, 8, ["item", "is-first", "is-last"]))
              }), 128)),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-primary",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addShortItem && _ctx.addShortItem(...args))),
                  disabled: _ctx.shortItems.length >= 10
                }, "項目を追加", 8, _hoisted_12)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}